import { render, staticRenderFns } from "./channelSelect.vue?vue&type=template&id=0d09588e"
import script from "./channelSelect.vue?vue&type=script&lang=js"
export * from "./channelSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports